import styled from 'styled-components';
import Check from 'assets/check.png';

export const TooltipContent = styled.div`
  color: #000;
  background-color: #fff;
  font-size: 0.75rem;
  p {
    margin: 5px 0px 0px;
  }
  p:first-child {
    margin-top: 0px;
  }
  > p > span.valid {
    color: #699838;
  }
  > p > span.tick-icon {
    background-image: url(${Check});
    background-repeat: no-repeat;
    width: 10px;
    height: 10px;
    display: inline-block;
    background-size: contain;
  }
`;
